import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { nomeCompleto } from '../data/marca';

/**
 * useTituloDaVertical — mantém o título da aba coerente com a instalação
 * CI Sistemas de Informática Ltda. — AcessoiD (Onda 79; nome do cliente na Onda 123)
 *
 * O `index.html` é um arquivo só, servido igual nas três verticais, então o
 * título dele tem de ser genérico. Quem sabe qual é a vertical — e, desde a
 * Onda 123, qual é o cliente — é o backend, e essa informação só chega depois
 * do login; daí o ajuste ser feito aqui, e não no HTML.
 *
 * Antes do login o título fica em "AcessoiD", sem descritor: chutar um valor
 * enquanto a vertical é desconhecida traria de volta o defeito que motivou isto.
 * (A tela de login põe o nome do cliente sozinha, pela rota pública de identidade.)
 */
export default function useTituloDaVertical() {
  const { vertical, clienteNome } = useAuth();

  useEffect(() => {
    document.title = nomeCompleto(vertical, clienteNome);
  }, [vertical, clienteNome]);
}
